import React from 'react';
import EmptyResult, { EmptyResultSize } from '../../../components/EmptyResult/EmptyResult';

const EmptySearchResults = () => <EmptyResult title='No Results Found' italicize size={EmptyResultSize.Small} />;

export default EmptySearchResults;
